module.exports = __webpack_public_path__ + "static/media/28DGC9.d110d363.jpg";